import { GeneralSearchEntityType } from './types';

// export const generalSearchOptionsORG = [
//   { id: GeneralSearchType.ARCHIVAL_AID, label: 'Archivní pomůcka' },
//   { id: GeneralSearchType.ARCHIVAL_COLLECTION, label: 'Archivní fond' },
//   { id: GeneralSearchType.ARCHIVAL_UNIT, label: 'Archiválie' },
//   { id: GeneralSearchType.EAD_NODE, label: 'Uzel EAD' },
// ];

export const generalSearchOptions = [
  { id: GeneralSearchEntityType.ARCHIVAL_AID, label: 'Archivní pomůcka' },
  { id: GeneralSearchEntityType.ARCHIVAL_COLLECTION, label: 'Archivní fond' },
  { id: GeneralSearchEntityType.ARCHIVAL_UNIT, label: 'Archiválie' },
  { id: GeneralSearchEntityType.EAD_NODE, label: 'Uzel EAD' },
  { id: GeneralSearchEntityType.ORIGINATOR, label: 'Rejstříkové heslo' },
  { id: GeneralSearchEntityType.SERIES, label: 'Série' },
  { id: GeneralSearchEntityType.FILE, label: 'Složka' },
];
